import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      className = _ref.className,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("thead", _extends({}, unhandledProps, {
    className: className
  }), children);
};

TableHead.displayName = 'TableHead';
export default TableHead;